const ArrowUpIcon = ({ ...props }) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.3536 8.14643C18.5488 8.34169 18.5488 8.65828 18.3536 8.85354L17.6464 9.56065C17.4512 9.75591 17.1346 9.75591 16.9393 9.56065L12 4.6213L7.06066 9.56064C6.8654 9.75591 6.54882 9.75591 6.35355 9.56064L5.64645 8.85354C5.45119 8.65828 5.45119 8.34169 5.64645 8.14643L11.6464 2.14643C11.8417 1.95117 12.1583 1.95117 12.3536 2.14643L18.3536 8.14643Z"
			fill="currentColor"
		/>
		<rect x="11" y="4" width="2" height="18" rx="0.5" fill="currentColor" />
	</svg>
)

export default ArrowUpIcon
